import type { BackendApiErrorUnion } from '@vs-shop/engine/data/error/backendApi/_internal/createBackendApiError';
import { makeCustomerModule } from '@vs-shop/engine/module/customer/makeCustomerModule';
import { CustomerMe, CustomerShow } from '@vs-shop/schemas/branded/CustomerSchema';
import { CustomerTokenRead, NewsletterSubscribeInput } from '../schema/openapi/backend';
import type { CustomerUpdateBaseInfo } from '../schema/openapi/backend';
import { decodeAuthTokenFromCookies } from '../flow/auth/decodeAuthToken';

const customerUpdateBody = (data: CustomerUpdateBaseInfo) => data;

const customerModule = makeCustomerModule({
  customerTokenRead: CustomerTokenRead,
  customerMe: CustomerMe,
  newsletterSubscribeInput: NewsletterSubscribeInput,
  customerShow: CustomerShow,
  customerEmail: (me) => me.email,
  customerShowEmail: (customer) => customer.email,
  customerUpdateBody,
  decodeAuthTokenFromCookies,
});

export const CreateCustomerTokenError = customerModule.CreateCustomerTokenError;
export const GetCustomerMeError = customerModule.GetCustomerMeError;
export const RefreshCustomerTokenError = customerModule.RefreshCustomerTokenError;
export const SubscribeNewsletterError = customerModule.SubscribeNewsletterError;
export const UpdateCustomerError = customerModule.UpdateCustomerError;
export const createCustomerToken = customerModule.createCustomerToken;
export const requestCustomerMe = customerModule.requestCustomerMe();
export const refreshCustomerToken = customerModule.refreshCustomerToken;
export const subscribeNewsletter = customerModule.subscribeNewsletter;
export const updateCustomer = customerModule.updateCustomer;

export type CustomerTokenCreateError = BackendApiErrorUnion<typeof CreateCustomerTokenError>;
export type CustomerGetCustomerMeError = BackendApiErrorUnion<typeof GetCustomerMeError>;
export type CustomerTokenRefreshError = BackendApiErrorUnion<typeof RefreshCustomerTokenError>;
export type NewsletterSubscribeError = BackendApiErrorUnion<typeof SubscribeNewsletterError>;
export type UpdateCustomerError = BackendApiErrorUnion<typeof UpdateCustomerError>;
